// extracted by mini-css-extract-plugin
module.exports = {"blocks":"Make1099Exceptions_blocks__WsRbN"};